/**
 * DTOs do sub-recurso `employees/:employeeId/notas-fiscais` (T-24).
 *
 * Contrato fonte: `kb-exports/colaboradores/ApiEmployeeNotasFiscais.spec.md`.
 * BFF wiring: `employee-notas-fiscais` em `genexus-routes.ts` + ações custom
 * `solicitar/aprovar/reprovar/file` em `proxy.plugin.ts`.
 */

export type NotaFiscalStatus = 'NSO' | 'SOL' | 'PAP' | 'APR' | 'REP' | 'CAN' | 'CON';

export interface EmployeeNotaFiscalDto {
  id: number;
  employeeId: number;
  colaboradorNome: string;

  clienteCodigo: number;
  clienteNome: string;

  periodo: string;
  mes: string;
  ano: number;
  status: NotaFiscalStatus;

  espelhoValor: number;
  espelhoTotalHoras: string;
  valorReceberFormula: number;
  valorRecebido: number;
  nfPaga: boolean;
  valeValor: number;

  apontamentoTotalHorasApontadas: string;
  apontamentoTotalHorasAjustadas: string;
  apontamentoValor: number;

  pdfNome: string | null;
  pdfTamanho: number | null;
  /** True quando o blob ColaboradorNotaFiscalPDF está preenchido. A lista ainda não envia; pdfNome sozinho não basta. */
  temPdf?: boolean | null;
  motivoReprovacao: string | null;
  faturamentoParcial: boolean;
  existeNotaEmpresa: boolean;

  dataCadastro: string;
  respCadastroGuid: string;
  respCadastroNome: string;
  dataSolicitacao: string | null;
  respSolicitacaoGuid: string | null;
  respSolicitacaoNome: string | null;
  dataAnexo: string | null;
  respAnexoGuid: string | null;
  respAnexoNome: string | null;
  dataAprovacao: string | null;
  respAprovacaoGuid: string | null;
  respAprovacaoNome: string | null;
}

export type EmployeeNotaFiscalListItem = EmployeeNotaFiscalDto;

/** O alerta do GeneXus testa o blob, não o nome. `temPdf` é esse teste; nome e tamanho cobrem o contrato antigo. */
export function notaFiscalTemPdf(nota: {
  temPdf?: boolean | null;
  pdfNome?: string | null;
  pdfTamanho?: number | string | null;
}): boolean {
  if (typeof nota.temPdf === 'boolean') return nota.temPdf;
  if (nota.pdfNome) return true;
  const tamanho = Number(nota.pdfTamanho);
  return Number.isFinite(tamanho) && tamanho > 0;
}

export interface EmployeeNotaFiscalInput {
  clienteCodigo: number;
  mes: number;
  ano: number;
}

/** Resposta de `getNotaFiscalEspelho`, sem gravar a nota. Horas em decimal. */
export interface NotaFiscalEspelho {
  tipoPagamento: 'H' | 'F' | string;
  valorHoraPagar: number;
  espelhoTotalHoras: number;
  espelhoValor: number;
  apontamentoTotalHoraPadrao: number;
  apontamentoValorHoraPadrao: number;
  apontamentoTotalHoraAdicional: number;
  apontamentoValorHoraAdicional: number;
  apontamentoTotalHoraPlantao: number;
  apontamentoValorHoraPlantao: number;
  apontamentoTotalHoraAcionamento: number;
  apontamentoValorHoraAcionamento: number;
  apontamentoTotalHoras: number;
  apontamentoValor: number;
}
